<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.46973 6.46973C9.76262 6.17683 10.2374 6.17683 10.5303 6.46973L15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L10.5303 17.5303C10.2374 17.8232 9.76262 17.8232 9.46973 17.5303C9.17683 17.2374 9.17683 16.7626 9.46973 16.4697L13.9395 12L9.46973 7.53027C9.17683 7.23738 9.17683 6.76262 9.46973 6.46973Z"
      fill="#7A7A7A" />
  </svg>
</template>
